import { createTheme } from '@mui/material/styles';

export const getTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? '#108EB6' : '#0A3D62',
      light: mode === 'dark' ? '#1CCDF7' : '#108EB6',
      dark: mode === 'dark' ? '#0A3D62' : '#072D48',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: mode === 'dark' ? '#1479B3' : '#0C4B7A',
      light: mode === 'dark' ? '#20E2FF' : '#1479B3',
      dark: mode === 'dark' ? '#0C4B7A' : '#083857',
      contrastText: '#FFFFFF',
    },
    background: {
      default: mode === 'dark' ? '#000000' : '#F8FAFC',
      paper: mode === 'dark' ? '#141414' : '#FFFFFF',
    },
    text: {
      primary: mode === 'dark' ? '#FFFFFF' : '#0A3D62',
      secondary: mode === 'dark' ? '#20E2FF' : '#0C4B7A',
    },
    error: {
      main: mode === 'dark' ? '#FF4B2B' : '#B64210',
      light: mode === 'dark' ? '#FF6B4A' : '#D65B1E',
      dark: mode === 'dark' ? '#CC3C22' : '#8C3008',
    },
    warning: {
      main: mode === 'dark' ? '#1479B3' : '#0E5C8C',
      light: mode === 'dark' ? '#20E2FF' : '#1479B3',
      dark: mode === 'dark' ? '#0E5C8C' : '#0A4670',
    },
    success: {
      main: mode === 'dark' ? '#10B6B6' : '#0A6262',
      light: mode === 'dark' ? '#1CE7E7' : '#108E8E',
      dark: mode === 'dark' ? '#0C8C8C' : '#074848',
    },
    grey: {
      50: mode === 'dark' ? '#1A1A1A' : '#F8FAFC',
      100: mode === 'dark' ? '#262626' : '#E6EEF4',
      200: mode === 'dark' ? '#333333' : '#D4E2EC',
      300: mode === 'dark' ? '#404040' : '#C2D6E4',
      400: mode === 'dark' ? '#595959' : '#B0CADC',
      500: mode === 'dark' ? '#737373' : '#9EBED4',
      600: mode === 'dark' ? '#8C8C8C' : '#8CB2CC',
      700: mode === 'dark' ? '#A6A6A6' : '#7AA6C4',
      800: mode === 'dark' ? '#BFBFBF' : '#689ABC',
      900: mode === 'dark' ? '#D9D9D9' : '#568EB4',
    },
    action: {
      active: mode === 'dark' ? '#20E2FF' : '#0A3D62',
      hover: mode === 'dark' ? 'rgba(32, 226, 255, 0.12)' : 'rgba(10, 61, 98, 0.08)',
      selected: mode === 'dark' ? 'rgba(32, 226, 255, 0.20)' : 'rgba(10, 61, 98, 0.16)',
      disabled: mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(10, 61, 98, 0.3)',
      disabledBackground: mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(10, 61, 98, 0.12)',
    },
    divider: mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(10, 61, 98, 0.12)',
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    allVariants: {
      fontFamily: 'Poppins, sans-serif',
    },
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
    subtitle1: {
      fontWeight: 400,
    },
    subtitle2: {
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0px 1px 2px rgba(15, 23, 42, 0.08)',
    '0px 2px 4px rgba(15, 23, 42, 0.08)',
    '0px 4px 8px rgba(15, 23, 42, 0.08)',
    '0px 6px 12px rgba(15, 23, 42, 0.08)',
    '0px 8px 16px rgba(15, 23, 42, 0.08)',
    '0px 12px 24px rgba(15, 23, 42, 0.08)',
    '0px 16px 32px rgba(15, 23, 42, 0.08)',
    '0px 20px 40px rgba(15, 23, 42, 0.08)',
    '0px 24px 48px rgba(15, 23, 42, 0.08)',
    '0px 28px 56px rgba(15, 23, 42, 0.08)',
    '0px 32px 64px rgba(15, 23, 42, 0.08)',
    '0px 36px 72px rgba(15, 23, 42, 0.08)',
    '0px 40px 80px rgba(15, 23, 42, 0.08)',
    '0px 44px 88px rgba(15, 23, 42, 0.08)',
    '0px 48px 96px rgba(15, 23, 42, 0.08)',
    '0px 52px 104px rgba(15, 23, 42, 0.08)',
    '0px 56px 112px rgba(15, 23, 42, 0.08)',
    '0px 60px 120px rgba(15, 23, 42, 0.08)',
    '0px 64px 128px rgba(15, 23, 42, 0.08)',
    '0px 68px 136px rgba(15, 23, 42, 0.08)',
    '0px 72px 144px rgba(15, 23, 42, 0.08)',
    '0px 76px 152px rgba(15, 23, 42, 0.08)',
    '0px 80px 160px rgba(15, 23, 42, 0.08)',
    '0px 84px 168px rgba(15, 23, 42, 0.08)',
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 20px',
          fontFamily: 'Poppins, sans-serif',
          transition: 'all 0.2s ease-in-out',
        },
        contained: {
          boxShadow: 'none',
          background: (theme) => 
            `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(15, 23, 42, 0.15)',
            transform: 'translateY(-1px)',
            background: (theme) => 
              `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
          },
          '&:active': {
            transform: 'translateY(0)',
          },
          '&.Mui-disabled': {
            background: (theme) => theme.palette.action.disabledBackground,
          },
        },
        outlined: {
          borderColor: (theme) => theme.palette.primary.main,
          '&:hover': {
            backgroundColor: (theme) => `${theme.palette.primary.main}10`,
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
        text: {
          '&:hover': {
            backgroundColor: (theme) => `${theme.palette.primary.main}10`,
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 8px rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          borderBottom: '1px solid #E2E8F0',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid #E2E8F0',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-selected': {
            backgroundColor: 'rgba(124, 58, 237, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(124, 58, 237, 0.12)',
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 40,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow: '0px 20px 40px rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
        },
      },
    },
  },
});

export const theme = getTheme('light');
export default theme;
